import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Form from '../../../commonComponents/forms/Form';
import translate from '../../../commonComponents/translate';
import Request from '../../../services/request';
import Notifications from '../../../services/notifications';
import { compose } from '../../../services/utilityFunctions';
import withCSRF from '../../../commonComponents/withCSRF';

function ContactForm({ t, _csrf }) {
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const setField = field => ({ target }) =>
    setForm(prev => ({ ...prev, [field]: target.value }));

  const validationRules = {
    name: { required: true },
    email: { required: true, email: true },
    message: { required: true },
  };

  const handleSubmit = () => {
    new Request(_csrf)
      .post('/contact/us', form)
      .done(() => {
        Notifications.showNotificationSuccess(
          t('success'),
          t('success_contact_form'),
        );
        window.location.reload();
      })
      .fail(err => {
        Notifications.showErrorFromRequest(err, 'error_contact_form');
      });
  };

  return (
    <div className="landing-contact-form-container">
      <div className="landing-contact-header">
        <h4 className="landing-contact-header-text">
          {t('landing_contact_title')}
        </h4>
      </div>
      <div className="landing-contact-body">
        <Form
          className="landing-contact-form"
          submitMethod={handleSubmit}
          id="landing-contact-form"
          validationRules={validationRules}
        >
          {submitHandler => (
            <>
              <input
                type="text"
                name="name"
                className="landing-contact-input"
                placeholder={t('landing_contact_name')}
                value={form.name}
                onChange={setField('name')}
              />
              <input
                type="email"
                name="email"
                className="landing-contact-input"
                placeholder={t('landing_contact_email')}
                value={form.email}
                onChange={setField('email')}
              />
              <textarea
                name="message"
                rows={4}
                className="landing-contact-input"
                placeholder={t('landing_contact_message')}
                value={form.message}
                onChange={setField('message')}
              />
              <button
                type="button"
                className="landing-contact-submit btn m-btn--pill btn-dynamic"
                onClick={submitHandler}
              >
                {t('send')}
              </button>
              <div className="landing-contact-time-notice">
                <span className="m--font-danger">*</span>
                <span>{t('landing_contact_notice')}</span>
              </div>
            </>
          )}
        </Form>
      </div>
    </div>
  );
}

ContactForm.propTypes = {
  t: PropTypes.func.isRequired,
  _csrf: PropTypes.string.isRequired,
};

export default compose(
  withCSRF,
  translate,
)(ContactForm);
